export default {
  title: 'Rejoignez {{name}} !',
  default_program_name: 'Club de récompenses',
  benefits: {
    earn_points: 'Gagnez des points à chaque commande',
    get_deals: 'Recevez des remises exclusives',
    redeem_points: 'Échangez vos points contre de la nourriture gratuite',
  },
  terms: 'En vous inscrivant, vous recevrez des offres par e-mail et SMS de notre&nbsp;',
  buttons: {
    log_in: 'Se connecter',
    sign_up: "S'inscrire",
  },
  labels: {
    already_have_account: 'Vous avez déjà un compte ?',
  },
  signup_note:
    'En vous inscrivant, vous recevrez des offres par e-mail et SMS de notre <0>restaurant</0> et de <1>FoodAmigos</1>, notre partenaire technologique. Vous acceptez nos <2>Conditions de la plateforme</2> et notre <3>Politique de confidentialité</3>.',
};
